<div class="side-bar section-padding pb-0 mb-md-40">
  <div class="main-box padding-20 side-blog mb-xl-20">
    <h4 class="text-light-black">Popular Post</h4>
    <ng-container *ngIf="popularPosts.length; else noPopular">
      <article
        class="side-post pb-xl-20 mb-xl-20 u-line"
        *ngFor="let post of popularPosts"
      >
        <div class="thumb-img">
          <a [routerLink]="['/blog-details', post.id]">
            <img
              [src]="post.afterPhotoUrl || post.beforePhotoUrl"
              alt="thumb-img"
              class="img-fluid"
            />
          </a>
        </div>
        <div class="content-wrap">
          <div class="entry-meta-content">
            <h5 class="entry-title">
              <a
                [routerLink]="['/blog-details', post.id]"
                class="text-light-black"
              >
                {{ post.description || post.storeName }}
              </a>
            </h5>
            <div class="entry-tye">
              <span class="text-light-green fw-600">
                {{ post.createdTime | date : "mediumDate" }}
              </span>
            </div>
          </div>
        </div>
      </article>
    </ng-container>
    <ng-template #noPopular>
      <p class="text-light-white mb-0">No popular posts yet.</p>
    </ng-template>
  </div>

  <div class="main-box padding-20 blog-tags mb-xl-20" *ngIf="allTags.length">
    <h4 class="text-light-black">Tags</h4>
    <ng-container *ngFor="let tag of allTags">
      <a
        href="javascript:void(0)"
        (click)="onTagClick(tag, $event)"
        (touchend)="onTagClick(tag, $event); $event.preventDefault()"
        [class.active]="isTagSelected(tag)"
        style="
          cursor: pointer;
          touch-action: manipulation;
          min-height: 44px;
          display: inline-flex;
          align-items: center;
        "
        [title]="
          isTagSelected(tag) ? 'Click to clear filter' : 'Filter by ' + tag
        "
      >
        #{{ tag }}
      </a>
    </ng-container>
    <a
      *ngIf="selectedTag"
      href="javascript:void(0)"
      (click)="tagSelected.emit(null); $event.preventDefault()"
      (touchend)="tagSelected.emit(null); $event.preventDefault()"
      style="
        cursor: pointer;
        touch-action: manipulation;
        min-height: 44px;
        display: inline-flex;
        align-items: center;
        margin-top: 10px;
        font-size: 12px;
        color: #666;
        text-decoration: underline;
      "
      title="Clear filter"
    >
      Clear filter
    </a>
  </div>

  <div
    class="main-box padding-20 trending-blog-cat mb-xl-20"
    *ngIf="popularPosts.length"
  >
    <h4 class="text-light-black">Stores</h4>
    <ul>
      <li class="pb-xl-20 u-line mb-xl-20" *ngFor="let post of popularPosts">
        <a
          *ngIf="post.storeId !== 'general-store'"
          class="text-light-black fw-600"
          [routerLink]="['/blog-details', post.id]"
        >
          {{ post.storeName }}
          <span class="text-light-white fw-400"
            >({{ post.topics?.length || 0 }})</span
          >
        </a>
        <a
          *ngIf="post.storeId === 'general-store'"
          class="text-light-black fw-600"
          [routerLink]="['/blog-details', post.id]"
          >No tagged store</a
        >
      </li>
    </ul>
  </div>
</div>
